'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { Env } from '@/consts/Env';
import { useUserMeQuery } from '@/queries/user/user.queries';
import { ensureOneSignalReady, ONE_SIGNAL_SCRIPT_SRC, syncOneSignalIdentity } from './utils/oneSignal.client';
import { OneSignalPushNotificationQueryListener } from './utils/queryListener';

export default function OneSignalInit() {
  const { data: user } = useUserMeQuery();
  const appId = Env.NEXT_PUBLIC_ONE_SIGNAL_APP_ID;

  useEffect(() => {
    if (typeof window === 'undefined' || !appId) {
      return;
    }

    ensureOneSignalReady(appId).catch(() => {
      // ignore OneSignal init errors
    });
  }, [appId]);

  useEffect(() => {
    if (typeof window === 'undefined' || !appId) {
      return;
    }

    syncOneSignalIdentity(user?.id, appId).catch(() => {
      // ignore OneSignal identity sync errors
    });
  }, [appId, user?.id]);

  return (
    <>
      <Script
        id="onesignal-sdk"
        src={ONE_SIGNAL_SCRIPT_SRC}
        strategy="afterInteractive"
      />
      <OneSignalPushNotificationQueryListener user={user ? { id: user.id, email: user.email } : undefined} />
    </>
  );
}
